module.exports = __webpack_public_path__ + "static/media/screens-bg.c1d6b811.jpg";